module.exports = __webpack_public_path__ + "img/star sapphire_lw.fc570ffb.png";